.badge {
  background-color: transparent;
  padding-inline: 0;
}

.badge span {
  font-size: 11px;
  font-weight: var(--cxy-fontWeight-semiBold);
  line-height: var(--cxy-lineHeight-xxs);
}

.ai {
  font-weight: var(--cxy-fontWeight-normal);
  text-transform: uppercase;
}

/* Gazzetta theme overrides */
[data-fpsm-theme='gazzetta'] {
  .badge {
    color: var(--cxy-color-black);
  }

  .statsIcon {
    filter: brightness(0);
  }
}
